const SET_CURRENT_ASCEND_DATA = 'set-current-ascend-data';
const SET_ASCEND_FETCH_STATUS = 'set-ascend-fetch-status';
const SET_REMOVE_ASCEND_FEATURES = 'set-remove-ascend-features';

export default {
  SET_CURRENT_ASCEND_DATA,
  SET_ASCEND_FETCH_STATUS,
  SET_REMOVE_ASCEND_FEATURES,
};
